import styled from 'styled-components'

export const Container = styled.div`
  padding-bottom: 50px;
`

export const Title = styled.div`
  color: ${({ theme }) => theme.colors.grayscale.black};
  font-family: ${({ theme }) => theme.fontFamilies.robotoCondensed};
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  margin-bottom: 20px;
`

export const ButtonGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-auto-flow: row;
  justify-items: center;
  gap: 20px;
  @media (min-width: 576px) {
    grid-template-columns: repeat(3, 1fr);
  }
`

export const ButtonContainer = styled.div`
  text-align: center;
  min-width: 60%;
  @media (min-width: 576px) {
    width: 100%;
  }
`

export const Button = styled.button<{ active?: boolean }>`
  color: ${({ theme }) => theme.colors.coolGray.cool900};
  background-color: ${({ theme }) => theme.colors.coolGray.cool150};
  border-radius: 8px;
  display: block;
  padding: 20px;
  margin: auto;
  font-size: 14px;
  line-height: 18px;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  width: 60vw;
  border-width: 2px;
  border-style: solid;
  border-color: ${({ theme, active = false }) =>
    active ? theme.colors.brand.blue : 'transparent'};
  transition: all 0.15s;
  @media (min-width: 576px) {
    width: 100%;
  }
  &:focus {
    outline: none;
  }
  &:hover {
    background-color: ${({ theme }) => theme.colors.coolGray.cool200};
    border-color: ${({ theme, active }) => (active ? 'inherit' : theme.colors.coolGray.cool250)};
  }
  &:active {
    background-color: ${({ theme }) => theme.colors.coolGray.cool250};
    border-color: ${({ theme }) => theme.colors.coolGray.cool450};
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

export const TypeName = styled.strong`
  display: block;
  font-weight: 700;
  text-transform: uppercase;
`

export const Helper = styled.span`
  display: block;
  font-size: 12px;
  font-style: normal;
  line-height: 18px;
  text-align: center;
  color: ${({ theme }) => theme.colors.grayscale.black};
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 10px;
`
